import React from 'react';
import { Checkbox } from '@ipc/ipc-components';

import { CheckboxWrapper } from './styles';

export default props => <CheckboxWrapper dataTestid="checkbox"><Checkbox labelPlacement="start" {...props} /></CheckboxWrapper>;
